import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { login, register } from '../api/auth';
import { useAuth } from '../lib/AuthContext';

// 生产环境关闭公开注册 —— Vite 构建时 import.meta.env.PROD 为 true
// 开发本地 npm run dev 仍能看到注册入口便于测试
const ALLOW_REGISTRATION = !import.meta.env.PROD;

export default function Login() {
  const nav = useNavigate();
  const { refreshMe } = useAuth();
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const [companyName, setCompanyName] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^1\d{10}$/.test(phone)) { setError('请输入 11 位手机号'); return; }
    if (password.length < 6) { setError('密码至少 6 位'); return; }
    if (mode === 'register' && !companyName.trim()) { setError('请填公司名'); return; }

    try {
      setBusy(true); setError(null);
      if (mode === 'login') {
        await login({ phone, password });
      } else {
        await register({ company_name: companyName, phone, password });
      }
      await refreshMe();
      nav('/');
    } catch (e: any) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container narrow" style={{ maxWidth: 420, marginTop: 60 }}>
      <div className="card">
        <h1 style={{ textAlign: 'center', marginBottom: 24 }}>
          {mode === 'login' ? '登录' : '注册公司账号'}
        </h1>

        {error && <div className="banner error">{error}</div>}

        <form onSubmit={handleSubmit} className="col" style={{ gap: 16 }}>
          {mode === 'register' && (
            <label>
              <div className="hint" style={{ marginBottom: 4 }}>公司名称</div>
              <input value={companyName} onChange={(e) => setCompanyName(e.target.value)}
                placeholder="如:字节跳动" autoFocus />
            </label>
          )}

          <label>
            <div className="hint" style={{ marginBottom: 4 }}>手机号</div>
            <input value={phone} onChange={(e) => setPhone(e.target.value)}
              placeholder="11 位手机号" maxLength={11}
              autoFocus={mode === 'login'} />
          </label>

          <label>
            <div className="hint" style={{ marginBottom: 4 }}>密码</div>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="至少 6 位" />
          </label>

          <button type="submit" disabled={busy}>
            {busy ? '处理中...' : mode === 'login' ? '登录' : '注册并登录'}
          </button>
        </form>

        {ALLOW_REGISTRATION && (
          <div style={{ textAlign: 'center', marginTop: 16 }}>
            {mode === 'login' ? (
              <span className="hint">
                没有账号? <a onClick={() => setMode('register')} style={{ cursor: 'pointer' }}>立即注册</a>
              </span>
            ) : (
              <span className="hint">
                已有账号? <a onClick={() => setMode('login')} style={{ cursor: 'pointer' }}>去登录</a>
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
